// extracted by mini-css-extract-plugin
export default {"loader":"index_loader__SBr-d","dot":"index_dot__5fV9r","glow":"index_glow__0xJvd"};